import { nanoid } from 'nanoid';
import Cookies from 'js-cookie';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

export class CSRFProtection {
  private static instance: CSRFProtection;
  private token: string | null = null;

  private constructor() {}

  public static getInstance(): CSRFProtection {
    if (!CSRFProtection.instance) {
      CSRFProtection.instance = new CSRFProtection();
    }
    return CSRFProtection.instance;
  }

  public generateToken(): string {
    this.token = nanoid(32);
    Cookies.set(CSRF_COOKIE_NAME, this.token, {
      secure: true,
      sameSite: 'strict',
      httpOnly: false
    });
    return this.token;
  }

  public getToken(): string | null {
    if (!this.token) {
      this.token = Cookies.get(CSRF_COOKIE_NAME) || null;
    }
    return this.token;
  }

  public getHeaders(): Record<string, string> {
    const token = this.getToken();
    if (!token) {
      this.generateToken();
      return { [CSRF_HEADER_NAME]: this.token! };
    }
    return { [CSRF_HEADER_NAME]: token };
  }

  public clearToken(): void {
    this.token = null;
    Cookies.remove(CSRF_COOKIE_NAME);
  }
}

export const csrfProtection = CSRFProtection.getInstance();